import { CheckCircleIcon, ExclamationTriangleIcon } from '@heroicons/react/24/outline';

export default function DataConfidenceBadge({ confidence = 0, agesDays = 0, dataFreshness = 'stale' }) {
  const getColor = () => {
    if (dataFreshness === 'fresh') return 'bg-green-100 text-green-700 border-green-300';
    if (dataFreshness === 'recent') return 'bg-blue-100 text-blue-700 border-blue-300';
    if (dataFreshness === 'adequate') return 'bg-amber-100 text-amber-700 border-amber-300';
    return 'bg-red-100 text-red-700 border-red-300';
  };

  const getIcon = () => {
    if (dataFreshness === 'fresh' || dataFreshness === 'recent') {
      return <CheckCircleIcon className="w-3 h-3 inline mr-1" />;
    }
    return <ExclamationTriangleIcon className="w-3 h-3 inline mr-1" />;
  };

  const getLabel = () => {
    if (dataFreshness === 'fresh') return '✓ Fresh';
    if (dataFreshness === 'recent') return '↻ Recent';
    if (dataFreshness === 'adequate') return '~ Adequate';
    return '⚠ Stale';
  };

  return (
    <div
      className={`inline-flex items-center px-2 py-1 rounded-full border text-xs font-medium ${getColor()}`}
      title={`Data confidence: ${Math.round(confidence)}% (${Math.round(agesDays * 10) / 10} days old)`}
    >
      {getIcon()}
      {getLabel()}
    </div>
  );
}
